<template>
  <div
    :data-active="!disabled && isOver"
    @dragenter.prevent="!disabled && setIsOver(true)"
    @dragover.prevent="!disabled && setIsOver(true)"
    @dragleave.prevent="!disabled && setIsOver(false)"
    @drop.prevent="!disabled && onDrop"
  >
    <slot :active="isOver" />
  </div>
</template>

<script lang="ts" setup>
// make sure to import `ref` from Vue
import { ref } from 'vue';

interface Props {
  disabled?: boolean;
}

defineProps<Props>();

const emit = defineEmits(['files']);

const isOver = ref(false);

const setIsOver = (value: boolean) => {
  isOver.value = value;
};

const onDrop = (e: DragEvent) => {
  isOver.value = false;
  emit('files', [...(e.dataTransfer?.files ?? [])]);
};
</script>

<style lang="scss" scoped>
.file-upload {
  @apply h-full flex flex-col justify-center items-center cursor-pointer;
}

.dropzone {
  @apply w-full h-full;
}
</style>
